export const formatWeightTons = (weightKg: unknown, minimumFractionDigits = 2): string => {
  const weight = Number(weightKg);
  return ((Number.isFinite(weight) ? weight : 0) / 1000).toLocaleString("en-US", {
    minimumFractionDigits,
    maximumFractionDigits: 2,
    useGrouping: false,
  });
};

export const formatItemWeightKg = (unitWeight: unknown, quantity: unknown): string => {
  if (unitWeight == null || quantity == null) return "-";
  const total = Number(unitWeight) * Number(quantity);
  return Number.isFinite(total) ? total.toFixed(2) : "-";
};
